import {AfterViewInit, Component, EventEmitter, Host, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {DialogData} from '../zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import {MatSort} from '@angular/material/sort';
import {select, Store} from '@ngrx/store';
import {loadSeekStart} from '../../store/actions/Zeit-seek.actions';
import {Zeitstate} from '../../store/reducer/zeiterfassung.reducer';
import {MatDialog} from '@angular/material/dialog';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {Security} from '../../../../security';
import {Observable} from 'rxjs';
import {BreakpointObserver} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {SaldoItem} from '@src/app/pages/Mitarbeiterverwaltung/saldo.model';

@Component({
  selector: 'app-zeiterfassung-table',
  templateUrl: './zeiterfassung-table.component.html',
  styleUrls: ['./zeiterfassung-table.component.scss']
})

export class ZeiterfassungTableComponent implements OnInit, AfterViewInit {

  constructor(private breakpointObserver: BreakpointObserver,
              public dialog: MatDialog,
              public store: Store<{ zeiterfassung: Zeitstate }>,
              public http: HttpClient,
              public router: Router,
              public security: Security) {}
  /* ENDE Beim Leeren des Datepickers wird an der leeren Stelle das Grid neu geladen */

  public show: Observable<boolean>;

  /**
   * Sets parts of the time mask to datasource
   *
   * @param Zeit - Parts of the time table
   */
  @Input()
  public set zeit(Zeit: DialogData[]) {
    this.dataSource.data = Zeit;
    this.getTotalDauerintern();
  }

  @Input()
  public set saldo(saldo: SaldoItem) {
    this.userId = saldo.userId;
    this.zeitSaldo = saldo.zeit;
    this.ferienSaldo = saldo.ferien;
    this.datumSaldo = saldo.datum;
  }

  public iWertVar;
                                      /*'id',*/
  // tslint:disable-next-line:max-line-length
  public displayedColumns: string[] = ['projekt' , 'projektName', 'datum', 'dauerIntern', 'dauerExtern', 'spesen' , 'text', 'verrechnen', 'niverbar', 'verrechnet'];
  public isSmallDevice = false;
  public datumSaldo = null;
  public zeitSaldo = null;
  public ferienSaldo = null;
  public dataSource = new MatTableDataSource<DialogData>();
  public dauerInternTotal = '';
  public dauerExternTotal = '';
  public spesenTotalIntern = '';
  public bNewShow = null;
  public userId = 0;
  @Input()
  public showFunctionMenu = true;


  @Output()
  public delete = new EventEmitter<DialogData>();

  @Output()
  public edit = new EventEmitter<DialogData>();

  @Output()
  public saldoReport = new EventEmitter<number>();

  @Output()
  public openFerienReport = new EventEmitter<number>();

  @Output()
  public openAuswertungen = new EventEmitter<number>();

  @Output()
  public loadReport = new EventEmitter<{ showBenutzername: boolean,
    showZwischensummen: boolean,
    showDetails: boolean,
    showSeparat: boolean,
    showAllUsers: boolean,
    filterDatumStart: string,
    filterDatumEnde: string,
    zeitAuswahl: number,
    spesenAuswahl: number
  }>();

  /* sortieren der Id */
  @ViewChild(MatSort) sort: MatSort;
  /* Ende sortieren der Id */




  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;

    this.security.checkLogin('3002').subscribe(
      x => {
    console.log(x);
    this.bNewShow = x;

  });
  }



  ngOnInit(): void {
    this.show = this.security.checkIfAllowed('3002');
    if (this.showFunctionMenu) {
      this.displayedColumns = this.displayedColumns.concat('actions');
    }
    this.breakpointObserver
      .observe(localStorage.getItem('phoneWidth'))
      .pipe(map((result) => result.matches))
      .subscribe((isSmallDevice) => {
        if (this.isSmallDevice && !isSmallDevice) {
          this.displayedColumns = ['projekt' , 'projektName', 'datum', 'dauerIntern', 'dauerExtern', 'spesen' , 'text', 'verrechnen', 'niverbar', 'verrechnet', 'actions'];
        }
        if(isSmallDevice) {
          this.displayedColumns = ['projekt', 'projektName', 'datum', 'dauerIntern', 'actions'];
        }
        this.isSmallDevice = isSmallDevice;

      });
  }

  public getTotalDauerintern(): void {
    if(this.dataSource.data.length === 0){
      this.dauerInternTotal = '0';
      this.dauerExternTotal = '0';
      this.spesenTotalIntern = '0';
      return;
    }
    this.dauerInternTotal = this.dataSource.data.map(t => t.dauerIntern).reduce((acc, value) => acc + value);
    this.dauerExternTotal = this.dataSource.data.map(t => t.dauerExtern).reduce((acc, value) => acc + value);
    this.spesenTotalIntern = this.dataSource.data.map(t => t.spesenTotal).reduce((acc, value) => acc + value).toString();
    //this. = this.dataSource.data.map(t => t.spesenTotal).reduce((acc, value) => acc + value);
  }
}
